module.exports = __webpack_public_path__ + "img/printAssociationIndex_bg.00be632b.jpg";